module.exports = __webpack_public_path__ + "img/add-user.8568e900.svg";